package com.fireavert.administration.super_admin_tools_page.data_models.models

import kotlinx.serialization.Serializable

@Serializable
data class PropertyNotificationStatsModel(
    val propertyId: Int,
    val propertyName: String,
    val hasLeakSensors: Boolean,
    val hasTamperSensors: Boolean,
    val hasTextNotificationsForFA: Int,
    val hasEmailNotificationForFA: Int,
    val hasTextNotificationsForLeak: Int,
    val hasEmailNotificationForLeak: Int,
    val hasTextNotificationForTamper: Int,
    val hasEmailNotificationForTamper: Int,
)